import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.alerts-report-table', () => {
  import('./internal/alerts-report-table').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.alert_form', () => {
  import('./internal/alert_form').then(({ default: Component }) => Component());
});
